<template>
  <div class="content">

    <div class="lineBox" style="padding-bottom:50px;padding-top:10px;border:0px;">
      <span class="h3" style="float:left;margin-top:5px;">Pedidos </span>
      <button class="buttonWire" style="width:80px;height:32px;margin-left:20px;float:left;" @click="updateTransactions()">Atualizar</button>
      <input type="text" placeHolder="número do pedido" style="height:30px;margin-left:20px;float:left;" class="inputText inputSearch" v-model="search"/>
      <div @click="clearSearch()" style="float:left;margin-top:5px;"><OpaIcon name="broom" style="margin-left:5px;cursor:pointer" /></div>
    </div>
    <div style="padding:8px;border:1px solid #ffffff;max-width:290px;border-radius:8px;float:left;">
      <div  style="margin:9px 6px;">
        Planilha de Pedidos Detalhada<br/>
        <select v-model="monthFinancial" style="height:30px;margin-right:8px;">
          <option value="1">Janeiro</option>
          <option value="2">Fevereiro</option>
          <option value="3">Março</option>
          <option value="4">Abril</option>
          <option value="5">Maio</option>
          <option value="6">Junho</option>
          <option value="7">Julho</option>
          <option value="8">Agosto</option>
          <option value="9">Setembro</option>
          <option value="10">Outubro</option>
          <option value="11">Novembro</option>
          <option value="12">Dezembro</option>
        </select>
        <select v-model="yearFinancial" style="height:30px;margin-right:8px;">
          <option v-for="(y, idxY) in [new Date().getFullYear(), new Date().getFullYear()-1, new Date().getFullYear()-2]" v-bind:key="idxY" :value="y">{{y}}</option>
        </select>
        <button @click="downloadBalanceSheet()" style="height:30px;width:80px;">Baixar</button>
      </div>
    </div>

    <div style="padding:8px;border:1px solid #ffffff;max-width:390px;border-radius:8px;float:left;margin-left:32px;">
      <div  style="margin:9px 6px;">
        Planilha de Pedidos Sintética<br/>
        <select v-model="dayFinancial2" style="height:30px;margin-right:8px;">
          <option value="0">Mensal</option>
          <option v-for="(d, idxd) in 31" :value="d" v-bind:key="idxd">{{d}}</option>
        </select>
        <select v-model="monthFinancial2" style="height:30px;margin-right:8px;">
          <option value="1">Janeiro</option>
          <option value="2">Fevereiro</option>
          <option value="3">Março</option>
          <option value="4">Abril</option>
          <option value="5">Maio</option>
          <option value="6">Junho</option>
          <option value="7">Julho</option>
          <option value="8">Agosto</option>
          <option value="9">Setembro</option>
          <option value="10">Outubro</option>
          <option value="11">Novembro</option>
          <option value="12">Dezembro</option>
        </select>
        <select v-model="yearFinancial2" style="height:30px;margin-right:8px;">
          <option v-for="(y, idxY) in [new Date().getFullYear(), new Date().getFullYear()-1, new Date().getFullYear()-2]" v-bind:key="idxY" :value="y">{{y}}</option>
        </select>
        <button @click="downloadBalanceSheetSimple()" style="height:30px;width:80px;">Baixar</button>
      </div>
    </div>

    <div style="clear:both;"></div>

    <div class="lineBox" style="margin-top:10px; min-height: 75px; ">
      <div class="filterTabs">
        <div class="tab" v-bind:class="{'active': tabIsActive(0)}" @click="filterByTab(0)">
          Todos
        </div>
        <div class="tab" v-bind:class="{'active': tabIsActive(STATUS_TRANS_PAY_CONFIRMED)}" @click="filterByTab(STATUS_TRANS_PAY_CONFIRMED)">
          Confirmado
        </div>
        <div class="tab" v-bind:class="{'active': tabIsActive(STATUS_KONDUTO_MANUAL)}" @click="filterByTab(STATUS_KONDUTO_MANUAL)">
          ANTIFRAUDE MANUAL
        </div>
        <div class="tab" v-bind:class="{'active': tabIsActive(STATUS_TRANS_REJECTED)}" @click="filterByTab(STATUS_TRANS_REJECTED)">
          Pgto. Rejeitado
        </div>
        <div class="tab" v-bind:class="{'active': tabIsActive(STATUS_TRANS_W8_DELIVERY)}" @click="filterByTab(STATUS_TRANS_W8_DELIVERY)">
          Preparo
        </div>
        <div class="tab" v-bind:class="{'active': tabIsActive(STATUS_TRANS_W8_TAKE)}" @click="filterByTab(STATUS_TRANS_W8_TAKE)">
          Retirada
        </div>
        <div class="tab" v-bind:class="{'active': tabIsActive(STATUS_TRANS_TRANSPORT)}" @click="filterByTab(STATUS_TRANS_TRANSPORT)">
          Transporte
        </div>
        <div class="tab" v-bind:class="{'active': tabIsActive(STATUS_WAITING_TRANSPORT)}" @click="filterByTab(STATUS_WAITING_TRANSPORT)">
          Aguard.Transporte
        </div>
        <div class="tab" v-bind:class="{'active': tabIsActive(STATUS_TRANS_DELIVERED)}" @click="filterByTab(STATUS_TRANS_DELIVERED)">
          Entregue
        </div>
        <div class="tab" v-bind:class="{'active': tabIsActive(STATUS_TRANS_REJECTED_BUYER)}" @click="filterByTab(STATUS_TRANS_REJECTED_BUYER)">
          Rejeitado
        </div>
      </div>
      <div style="padding:10px; ">
        <table class="table" cellpadding="0" cellspacing="0">
          <thead>
            <tr>
              <td>Pedido</td>
              <td>Preço Produtos</td>
              <td>Frete</td>
              <td>Descontos</td>
              <td>Juros</td>
              <td>Parcelas</td>
              <td>Status</td>
              <td>Entrega Agendada</td>
              <td>Entrega</td>
              <td>Atualizado</td>
              <td>CPF/CNPJ</td>
              <td>Nome</td>
              <td></td>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(t, idx ) in filteredSales" v-bind:key="idx">
              <td>
                <span v-if="t.stage === 'dev'" style="font-size:12px; color:#FF4E72">DEV_{{t.PurchaseNumber}}</span>
                <span v-else>{{t.PurchaseNumber}}</span>
              </td>
              <td style="text-align:right;">{{formatPrice(t.PurchaseValue)}}</td>
              <td style="text-align:right;">{{formatPrice(t.DeliveryTax)}}</td>
              <td style="text-align:right;">{{formatPrice((t.delivery_discount_applied || 0) + (t.voucher_discount_applied || 0))}}</td>
              <td style="text-align:right;">{{formatPrice(t.total_interest || 0)}}</td>
              <td style="text-align:right;">{{t.InstallmentNumber}}x</td>
              <td><div @click="openModalStatus(t)" :class="getStatusClass(t.Status)" style="max-width:140px;font-size: 12px;" >{{getStatusName(t.Status, t)}}</div></td>
              <td>{{t.DeliveryScheduleInfo}}</td>
              <td>
                <span  v-if="!t.willDelivery">Retirada em loja</span>
                <span v-else-if="t.Status === STATUS_TRANS_PAY_CONFIRMED || t.Status === STATUS_TRANS_REJECTED || t.Status === STATUS_TRANS_W8_TAKE || t.Status === STATUS_TRANS_CANCELED_BY_STORE || t.Status === STATUS_TRANS_CANCELED_BY_BUYER || t.Status === STATUS_TRANS_REJECTED_BUYER ||  t.Status === STATUS_PROCESSING_PAYMENT ||  t.Status === STATUS_TRANS_CREATED">-</span>
                <span v-else-if="t.Status === STATUS_TRANS_DELIVERED">Entregue</span>
                <button v-else-if="t.delivery_partner && !t.has_shopper && t.Status === STATUS_TRANS_W8_DELIVERY && !t.delivery_partner_called" @click="callDelivery(t)" style="width:186px;">Requisitar Entrega</button>
                <span v-else-if="t.delivery_partner_called">Entrega Requisitada</span>
                <span v-else>Entrega Própria</span>
              </td>
              <td>{{formatDateTime(t.StatusDate)}}</td>
              <td>{{t.cpfCnpjComprador}}</td>
              <td>{{t.FullName || ''}}</td>
              <td><div @click="openModalDetail(t)"><OpaIcon name="eye2x" color="green" style="cursor:pointer;"/></div></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <OpaModal v-model="showChangeStatus" width="400" height="420" header="Alterar Status">
      <div style="height:255px;overflow:auto; padding:20px;">
        <input :disabled="!checkPermission('view_pedidos_status_1')" type="radio" value="1" v-model="currentTransaction.Status" style="margin-bottom:5px;"/> Pedido Recebido<br/>
        <input :disabled="!checkPermission('view_pedidos_status_2')" type="radio" value="2" v-model="currentTransaction.Status" style="margin-bottom:5px;"/> Pagamento Confirmado<br/>
        <input :disabled="!checkPermission('view_pedidos_status_3')" type="radio" value="3" v-model="currentTransaction.Status" style="margin-bottom:5px;"/> Pagamento Rejeitado pelo Operador do Cartão<br/>
        <input :disabled="!checkPermission('view_pedidos_status_4')" type="radio" value="4" v-model="currentTransaction.Status" style="margin-bottom:5px;"/> Preparando Para Envio/Retirada<br/>
        <input :disabled="!checkPermission('view_pedidos_status_11')" type="radio" value="11" v-model="currentTransaction.Status" style="margin-bottom:5px;"/> Aguardando Transporte<br/>
        <input :disabled="!checkPermission('view_pedidos_status_5')" type="radio" value="5" v-model="currentTransaction.Status" style="margin-bottom:5px;"/> Em Transporte<br/>
        <input :disabled="!checkPermission('view_pedidos_status_6')" type="radio" value="6" v-model="currentTransaction.Status" style="margin-bottom:5px;"/> Entregue<br/>
        <input :disabled="!checkPermission('view_pedidos_status_7')" type="radio" value="7" v-model="currentTransaction.Status" style="margin-bottom:5px;"/> Cancelado pelo Lojista<br/>
        <input :disabled="!checkPermission('view_pedidos_status_8')" type="radio" value="8" v-model="currentTransaction.Status" style="margin-bottom:5px;"/> Cancelado pelo Consumidor<br/>
        <input :disabled="!checkPermission('view_pedidos_status_9')" type="radio" value="9" v-model="currentTransaction.Status" style="margin-bottom:5px;"/> Aguardando retirada na loja<br/>
        <input :disabled="!checkPermission('view_pedidos_status_10')" type="radio" value="10" v-model="currentTransaction.Status" style="margin-bottom:5px;"/> Rejeitado pelo Comprador<br/>
      </div>
      <div class="modal_footer">
        <button class="buttonFlat" style="width:80px;float:right;margin:20px;margin-right:20px;" @click="salvarStatus()">Salvar</button>
        <button class="buttonWire" style="width:80px;float:right;margin:20px;margin-right:0px;" @click="closeModalStatus()">Cancelar</button>
      </div>
    </OpaModal>

    <OpaModal v-model="showModalDetails" width="900" height="600" header="Detalhes da Compra">
      <div style="height:490px;overflow:auto;">
        <div v-if="currentTransaction.PurchaseNumber" style="color:#000000;background-color:#ffffff; padding:20px;" id="printable">
          <table style="width:100%">
            <tr>
              <td>
                <b>Número:</b> {{currentTransaction.PurchaseNumber}}<br/>
                <b>Id do cliente:</b> {{currentTransaction.UserId}}<br/>
                <b>Id:</b> {{currentTransaction.Id}}<br/><br/>
                <b>Produtos Comprados:</b> R$ {{formatPrice(currentTransaction.PurchaseValue)}}<br/>
                <b>Cupom de Desconto:</b> - R$ {{formatPrice(currentTransaction.voucher_discount_applied + (currentTransaction.delivery_discount_applied || 0 ))}}<br/>
                <b>Frete</b> R$ {{formatPrice(currentTransaction.DeliveryTax)}}<br/>
                <b>Serviço</b> R$ {{formatPrice(currentTransaction.service_fee)}}<br/>
                <b>Juros</b> R$ {{formatPrice(currentTransaction.total_interest || 0)}}<br/>
                <b>Total:</b> R$ {{formatPrice(currentTransaction.PurchaseValue - currentTransaction.voucher_discount_applied - (currentTransaction.delivery_discount_applied || 0) + currentTransaction.DeliveryTax + currentTransaction.service_fee + (currentTransaction.total_interest || 0))}}{{currentTransaction.InstallmentNumber > 1 ? ` em ${currentTransaction.InstallmentNumber}x` : ''}}<br/><br/>
                <div v-if="currentTransaction.deliveryPaymentType"><b>Método de Pagamento:</b> {{currentTransaction.deliveryPaymentType.name}}</div>
                <div v-else><b>Método de Pagamento:</b> Cartão de Crédito<br/><br/></div>
                <div v-if="currentTransaction.deliveryPaymentType && currentTransaction.deliveryPaymentType.input"><b>{{currentTransaction.deliveryPaymentType.input.name}}:</b> {{currentTransaction.deliveryPaymentType.input.default_value}}<br/><br/></div>
                <b>Vai entregar:</b> {{(currentTransaction.willDelivery === true ? 'Sim' : 'Retirada em Loja')}}<br/>
                <b>Entrega agendada para:</b> {{currentTransaction.DeliveryScheduleInfo}}<br/><br/>
              </td>
              <td width="150px;" valign="top">
                <img :src="this.getCompany().logo" style="max-width:150px;text-align:right;"/>
              </td>
            </tr>
          </table>

          <table style="width: 100%" v-if="rating">
            <b>Avaliação:</b> {{rating.rating}}<br/>
            <b>Itens para melhorar:</b><br/>
            <li v-for="(label, idx) in rating.translated_tag" v-bind:key="idx">{{label}}<br></li>
            <b>Chegou a tempo:</b> {{(rating.on_schedule ? 'Sim' : 'Não')}}<br/>
            <b>Comentário:</b> {{rating.comment}}<br/><br/>
          </table>

          <table style="width: 100%">
            <b>Status:</b> {{getStatusName(currentTransaction.Status, currentTransaction)}}<br/>
            <b>Data Atualização:</b> {{formatDateTime(currentTransaction.StatusDate)}}<br/><br/>
            <b>Histórico:</b>
          </table>

          <table style="border: 1px solid;width:100%;">
            <thead>
              <tr style="border: 1px solid;">
                <td>Data</td>
                <td>Status</td>
              </tr>
            </thead>
            <tr v-for="(sh, idx) in currentTransaction.StatusHistory" v-bind:key="idx" style="border: 1px solid;">
              <td>{{formatDateTime(sh.statusDate)}}</td>
              <td>{{getStatusName(sh.status, sh)}}</td>
            </tr>
          </table><br/>
          <div v-if="currentTransaction.CardName"><b>Nome no cartão:</b> {{currentTransaction.CardName}}<br/></div>
          <template v-if="currentTransaction.CardNumber">
            <b>Número do cartão:</b> {{currentTransaction.CardNumber.substring(0,4)}} xxxxx {{currentTransaction.CardNumber.substring((currentTransaction.CardNumber.length - 4))}}<br/>
            <template v-if="currentTransaction.card_flag"><b>Bandeira do cartão:</b> {{currentTransaction.card_flag.toUpperCase()}} <font-awesome-icon :icon="[this.cardLib(currentTransaction.card_flag), this.cardIcon(currentTransaction.card_flag)]"/><br/><br/></template>
            <template v-else><br/></template>
          </template>
          <b>Nome do Cliente:</b> {{currentTransaction.FullName}}<br/>
          <b>Cpf/Cnpj:</b> {{currentTransaction.cpfCnpjComprador}}<br/>
          <b>Telefone do Cliente:</b> {{currentTransaction.Phone}}<br/><br/>
          <b>Endereço do cliente:</b><br/>
            <b>Rua:</b> {{currentTransaction.PaymentAddress.name}}, {{currentTransaction.PaymentAddress.streetNumber}}<br/>
            <b>Bairro:</b> {{currentTransaction.PaymentAddress.vicinity}} - <b>Cidade:</b> {{currentTransaction.PaymentAddress.city}} -
            <b>Estado:</b> {{currentTransaction.PaymentAddress.state}} - <b>País:</b> {{currentTransaction.PaymentAddress.country}}<br/>
            <b>CEP:</b> {{currentTransaction.PaymentAddress.cep}} - <b>Complemento:</b> {{currentTransaction.PaymentAddress.more || ''}}
          <br/><br/>
          <b>Produtos:</b><br/>
          <table style="border: 1px solid;width:100%;">
            <thead>
              <tr style="border: 1px solid;">
                <td>Qtd</td>
                <td>EAN</td>
                <td>Nome</td>
                <td>Observação</td>
                <td style="min-width:100px;text-align:right;">Preço Sem <br/> Adicionais</td>
                <td style="min-width:100px;text-align:right;">Total</td>
              </tr>
            </thead>
            <tr v-for="(product, idx) in currentTransaction.ProductList" v-bind:key="idx" style="border: 1px solid;">
              <td>{{product.qtd ? product.qtd : product.purchased_quantity}} X</td>
              <td>{{product.EAN ? product.EAN : product.product_views[0].ean}}</td>
              <td>
                {{product.name}} {{"- " + formatDate(product.expires_at)}}
                <template v-if="product.options_chosen">
                  <br/>
                  <span v-for ="(choose, idxchosse) in product.options_chosen" v-bind:key="idxchosse">
                    <li v-for="(choice, idxchoice) in choose.choices" v-bind:key="idxchoice" style="font-size:12px;">
                      {{choice.quantity}} X {{choice.label}} +R${{formatPrice(choice.price)}}
                    </li>
                  </span>
                </template>
                <template v-if="product.product_views[0].view != null && product.product_views[0].view.length">
                  <br/>
                  <span v-for ="(view, idxview) in product.product_views[0].view" v-bind:key="idxview">

                    <!-- option_id -->
                    <!-- presentation_id -->
                    <b>{{getPresentatationName(product.presentations, view.presentation_id)}}</b>:<br/>
                    <li>
                      {{getOptionName(product.presentations, view.presentation_id, view.option_id)}}
                    </li>
                  </span>
                </template>
              </td>
              <td style="font-size:12px;">{{product.observation}}</td>
              <td style="text-align:right" v-if="currentTransaction.ShopperId && product.shopper_price">R$ {{formatPrice(product.shopper_price)}}</td>
              <td style="text-align:right" v-else-if="product.product_views[0].real_price">R$ {{formatPrice(product.product_views[0].real_price)}}</td>
              <td style="text-align:right" v-else-if="product.product_views[0].promotional_price">R$ {{formatPrice(product.product_views[0].promotional_price)}}</td>
              <td style="text-align:right" v-else>R$ {{formatPrice(product.product_views[0].price)}}</td>
              
              <td style="text-align:right" v-if="currentTransaction.ShopperId && product.shopper_price">R$ {{formatPrice(product.shopper_price * product.purchased_quantity)}}</td>
              <td style="text-align:right" v-else>R$ {{formatPrice((product.product_views[0].real_price + getFoodOptionsPrice(product.options_chosen)) * product.purchased_quantity)}}</td>
            </tr>
          </table>
        </div>
      </div>
      <div class="modal_footer">
        <button class="buttonFlat" style="width:80px;float:right;margin:10px;margin-right:20px;" @click="print()">Imprimir</button>
        <button class="buttonFlat" style="width:80px;float:right;margin:10px;margin-right:20px;" @click="openThermalPrinterModalDetail(currentTransaction)">Impressora Térmica</button>
        <button class="buttonWire" style="width:80px;float:right;margin:10px;margin-right:20px;" @click="closeModalDetail()">Cancelar</button>
      </div>
    </OpaModal>
  
    <OpaModal v-model="showThermalPrinterModalDetails" width="300" height="500" header="Impressora Térmica" style="font-family: monospace;">
    <div style="height:390px;overflow:auto;">
      <div v-if="currentTransaction.PurchaseNumber" style="color:#000000;background-color:#ffffff; text-align: left; padding:10px;" id="printableThermalPrinter">
        <table style="width:100%">
          <tr>
            <td>
              <div style="text-align: center;">--------------------------------<br/>
                {{currentTransaction.company_name}}<br/>
                --------------------------------<br/>
                <b>No Pedido:</b> {{currentTransaction.PurchaseNumber}}<br/>
                <!--b>Id Cliente:</b> {{currentTransaction.UserId}}<br/>
                <b>Id Transacao:</b> {{currentTransaction.Id}} -->
              </div>
              <div style="text-align: center;">--------------------------------</div>
              <b>Vai entregar:</b> {{(currentTransaction.willDelivery === true ? 'Sim' : 'Retirada em Loja')}}<br/>
              <div v-if="currentTransaction.DeliveryScheduleInfo"><b>Entrega agendada para:</b> {{currentTransaction.DeliveryScheduleInfo}}<br/></div>
              <b>Status:</b> {{getStatusName(currentTransaction.Status, currentTransaction)}}<br/>
              <b>Data Atualização:</b> {{formatDateTime(currentTransaction.StatusDate)}}<br/>
              <b>Dados do Cliente</b><br/>
              <b>Nome:</b> {{currentTransaction.FullName}}<br/>
              <!--b>Cpf/Cnpj:</b> {{currentTransaction.cpfCnpjComprador}}<br/-->
              <!--b>Telefone:</b> {{currentTransaction.Phone}}<br/-->
              <b>Endereço:</b><br/>
              <b>Rua:</b> {{currentTransaction.PaymentAddress.name}}, {{currentTransaction.PaymentAddress.streetNumber}}<br/>
              <b>Bairro:</b> {{currentTransaction.PaymentAddress.vicinity}} - <b>Cidade:</b> {{currentTransaction.PaymentAddress.city}} -
              <b>Estado:</b> {{currentTransaction.PaymentAddress.state}} - <b>País:</b> {{currentTransaction.PaymentAddress.country}}<br/>
              <b>CEP:</b> {{currentTransaction.PaymentAddress.cep}} 
              <div v-if="currentTransaction.PaymentAddress.more">- <b>Complemento:</b> {{currentTransaction.PaymentAddress.more || ''}}</div>
              <br/>
              <div style="text-align: center;">--------------------------------</div>
              <table style=" width:100%;">
                <thead>
                  <tr>
                    <td style=""><strong>Qtd</strong></td>
                    <td class="tdRight" style=""><strong>Item</strong></td>
                    <td style="text-align: right;"><strong>Preco</strong></td>
                  </tr>
                <thead/>
                  <tr v-for="(product, idx) in currentTransaction.ProductList" v-bind:key="idx" style="vertical-align: baseline;">
                    <td>{{product.qtd ? product.qtd : product.purchased_quantity}}x</td>
                    <td>
                      {{product.name}} {{"- " + formatDate(product.expires_at)}}<br/>
                      <template v-if="product.options_chosen">
                        <span v-for ="(choose, idxchosse) in product.options_chosen" v-bind:key="idxchosse">
                          <li v-for="(choice, idxchoice) in choose.choices" v-bind:key="idxchoice" style="font-size:12px;">
                            {{choice.quantity}} X {{choice.label}} +R${{formatPrice(choice.price)}}
                          </li>
                        </span>
                      </template>
                        <span v-if="product.observation">
                          Obs: {{product.observation}}
                        </span>
                      <template v-if="product.product_views[0].view != null && product.product_views[0].view.length">
                        <span v-for ="(view, idxview) in product.product_views[0].view" v-bind:key="idxview">
                          <b>{{getPresentatationName(product.presentations, view.presentation_id)}}</b>:<br/>
                          <li>
                            {{getOptionName(product.presentations, view.presentation_id, view.option_id)}}
                          </li>
                        </span>
                        <span v-if="product.id != currentTransaction.ProductList[currentTransaction.ProductList.length-1].id">
                          <li colspan="3">
                            <div style="text-align: center;">-</div>
                          </li>
                        </span>
                      </template>
                    </td>
                    <td style="text-align:right" v-if="product.product_views[0].real_price">R$ {{formatPrice((product.product_views[0].real_price + getFoodOptionsPrice(product.options_chosen)))}}</td>
                    <td style="text-align:right" v-else-if="product.product_views[0].promotional_price">R$ {{formatPrice(product.product_views[0].promotional_price)}}</td>
                    <td style="text-align:right" v-else>R$ {{formatPrice(product.product_views[0].price)}}</td>
                  </tr>
              </table>
              <div style="text-align: center;">--------------------------------</div>
              <b>Produtos Comprados:</b> R$ {{formatPrice(currentTransaction.PurchaseValue)}}<br/>
              <b>Cupom de Desconto:</b> - R$ {{formatPrice(currentTransaction.voucher_discount_applied + (currentTransaction.delivery_discount_applied || 0))}}<br/>
              <b>Frete / Serviço:</b> R$ {{formatPrice(currentTransaction.DeliveryTax + currentTransaction.service_fee)}}<br/>
              <b>Total:</b> R$ {{formatPrice(currentTransaction.PurchaseValue - currentTransaction.voucher_discount_applied - (currentTransaction.delivery_discount_applied || 0) + currentTransaction.DeliveryTax + currentTransaction.service_fee + (currentTransaction.total_interest || 0))}}{{currentTransaction.InstallmentNumber > 1 ? ` em ${currentTransaction.InstallmentNumber}x` : ''}}<br/>
              <div v-if="currentTransaction.deliveryPaymentType"><b>Método de Pagamento:</b> {{currentTransaction.deliveryPaymentType.name}}</div>
              <div v-else><b>Método de Pagamento:</b> Cartão de Crédito<br/><br/></div>
              <div v-if="currentTransaction.deliveryPaymentType && currentTransaction.deliveryPaymentType.input"><b>{{currentTransaction.deliveryPaymentType.input.name}}:</b> {{currentTransaction.deliveryPaymentType.input.default_value}}<br/><br/></div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="modal_footer">
      <button class="buttonFlat" style="width:80px;float:right;margin:10px;margin-right:20px;" @click="printThermalPrinter()">Imprimir</button>
      <button class="buttonWire" style="width:80px;float:right;margin:10px;margin-right:20px;" @click="closeThermalPrinterModalDetail()">Cancelar</button>
    </div>
  </OpaModal>
  </div>
</template>

<script>
import OpaIcon from '@/components/OpaIcon.vue'
import OpaModal from '@/components/OpaModal.vue'
import { EventBus } from '@/utils/event-bus'
import axios from 'axios'
import { mapGetters } from 'vuex'
import { Printd } from 'printd'
import formaters from '@/mixins/formater'
import permissions from '@/mixins/adminPermission'
import _ from 'lodash'
import RatingConn from '@/connection/rating'

export default {
  name: 'home',

  data () {
    return {
      clients: [],
      search: null,
      transactions: [],
      tabActive: 0,
      showChangeStatus: false,
      showModalDetails: false,
      showThermalPrinterModalDetails: false,
      currentTransaction: {},
      backupStatus: 0,
      STATUS_TRANS_CREATED: 1,
      STATUS_TRANS_PAY_CONFIRMED: 2,
      STATUS_DELIVERY_PAYMENT: 22,
      STATUS_TRANS_REJECTED: 3,
      STATUS_TRANS_W8_DELIVERY: 4,
      STATUS_TRANS_TRANSPORT: 5,
      STATUS_TRANS_DELIVERED: 6,
      STATUS_TRANS_CANCELED_BY_STORE: 7,
      STATUS_TRANS_CANCELED_BY_BUYER: 8,
      STATUS_TRANS_W8_TAKE: 9,
      STATUS_TRANS_REJECTED_BUYER: 10,
      STATUS_WAITING_TRANSPORT: 11,
      STATUS_PROCESSING_PAYMENT: 12,
      STATUS_KONDUTO_MANUAL: 23,

      cssText: `
        pre {
          color: #000;
        }
      `,

      cssThermalPrinter: `
        * {
          font-family: monospace;
          color: black;
        }
      `,

      offsetDate: null,
      pageSize: 60,
      offsetId: null,
      loading: false,
      lastPurchase: 0,

      rating: {},

      monthFinancial: new Date().getMonth() + 1,
      yearFinancial: new Date().getFullYear(),


      dayFinancial2: 0,
      monthFinancial2: new Date().getMonth() + 1,
      yearFinancial2: new Date().getFullYear()
      

    }
  },

  created () {
    this.getAllClients ()
    this.getTransactions()
    setTimeout(this.autoUpdate, 30000)
  },

  mounted() {
    this.d = new Printd()
    EventBus.$on('maxScrollY', async () => {

      if (this.offsetId && !this.loading) {
        this.getTransactions()
      }
    })
  },

  async destroyed() {
    EventBus.$off('maxScrollY')
  },

  components: {
    OpaIcon, OpaModal
  },

  mixins: [formaters, permissions],

  computed: {
    ...mapGetters([ 'getCheckoutApi', 'getOpaApi', 'getDeliveryApi' ]),

    filteredSales () {
      if (this.tabActive === 0 && (!this.search || this.search.length === 0)) {
        return this.transactions
      } else {
        if (this.search && this.search.length > 0) {
          return this.transactions.filter(t => t.PurchaseNumber .indexOf(this.search) > -1)
        } else {
          return this.transactions.filter(t => t.Status === this.tabActive)
        }
      }
    }
  },

  methods: {
    ...mapGetters([ 'getAdmin', 'getCompany' ]),

    getPresentatationName(presentations, presentationId) {
      let name = '';
      let presentationFilter = presentations.filter((pres) => pres.id ==  presentationId);
      if (presentationFilter !== null && presentationFilter.length) {
        name = presentationFilter[0].name
      }
      return name;
    },

    getOptionName(presentations, presentationId, optionId) {
      let name = '';
      let presentationFilter = presentations.filter((pres) => pres.id ==  presentationId);
      if (presentationFilter !== null && presentationFilter.length) {
        let options = presentationFilter[0].options
        let optionsFilter = options.filter((opt) => opt.id === optionId);
        if (optionsFilter != null && optionsFilter.length){
          name = optionsFilter[0].label
        }
      }
      return name;
    },

    getFoodOptionsPrice(options_choosen) {
      let total = 0
      if (options_choosen && options_choosen.length) {
        for (let x=0; x<options_choosen.length; x++){
          if (options_choosen[x].choices && options_choosen[x].choices.length) {
            for (let y=0; y<options_choosen[x].choices.length; y++){
              if (options_choosen[x].choices[y].price && options_choosen[x].choices[y].quantity) {
                total = total + (options_choosen[x].choices[y].price * options_choosen[x].choices[y].quantity)
              }
            }
          }
        }
      }
      return total
    },

    getClientName(id) {
      if(this.clients && this.clients.length){
        let clis = this.clients.filter(c => c.id === id)
        if (clis.length) {
          return clis[0].name + ' ' + clis[0].familyName
        } else {
          return 'venda do marketplace'
        }
      }
    },

    getStatusInterno (codeComp) {
      let statusC = [{code:0, name: 'Nenhum'}]
      if (codeComp === this.STATUS_TRANS_PAY_CONFIRMED) {
        statusC.push({code:1, name: 'Faltando Item'})
        statusC.push({code:2, name: 'Produtos Separados'})
      } else if (codeComp === this.STATUS_TRANS_W8_DELIVERY) {
        statusC.push({code:3, name: 'Entregue a Transportadora'})
        statusC.push({code:4, name: 'Aguardando Transportadora'})
      } else if (codeComp === this.STATUS_TRANS_W8_TAKE) {
        statusC.push({code:5, name: 'Retirado pelo cliente'})
        statusC.push({code:6, name: 'Produto não retirado'})
      } else if (codeComp === this.STATUS_TRANS_TRANSPORT) {
        statusC.push({code:7, name: 'Aguardando finalização da entrega'})
        statusC.push({code:8, name: 'Segunda tentativa de entrega'})
        statusC.push({code:9, name: 'Cliente não encontrado'})
      }
      return statusC
    },

    async getRatingByOrderId(orderId) {
      this.rating = await RatingConn.getRatingByOrderIdFromApi(orderId)
      if (this.rating) {
        this.rating.translated_tag = this.rating.improvement_tag_list.map(tag => this.getToImproveName(tag))
      }
    },

    getToImproveName (tag) {
      let statusString = 'Indefinido'

      switch (tag) {
        case 'DELIVERY_TIME':
          statusString =  "Tempo de entrega"
          break;
        case 'CUSTOMER_SERVICE':
          statusString =  "Atendimento do restaurante"
          break;
        case 'FOOD':
          statusString =  "Comida"
          break;
        case 'PACKING':
          statusString =  "Embalagem"
          break;
        case 'WRONG_ITEMS':
          statusString =  "Itens errados"
          break;
        case 'MOTOBOY':
          statusString =  "Postura do entregador"
          break;
      }
      return statusString
    },

    clearSearch () {
      this.search = null
    },

    updateTransactions () {
      this.refreshTransactions()
      //document.location.reload(true)
    },

    salvarStatus () {
      let vm = this
      EventBus.$emit('showLoading', true)
      axios.put(vm.getCheckoutApi + '/transaction/' + this.currentTransaction.Id + '/' + this.currentTransaction.Status)
        .then((r) => {
          if (r.data.status && r.data.status === 'error'){
            EventBus.$emit('showLoading', false)
            EventBus.$emit('showAlert', 'warning', r.data.msg)
            vm.currentTransaction.Status = vm.backupStatus
          } else {
            this.showChangeStatus = false
            vm.getTransactions (() => {
              if (this.currentTransaction.Status === vm.STATUS_WAITING_TRANSPORT && this.currentTransaction.delivery_partner) {
                this.currentTransaction.delivery_partner_called = true
                EventBus.$emit('showAlert', 'success', 'Seu entregador chegará em alguns minutos.')
              } else {
                EventBus.$emit('showAlert', 'success', 'atualizado com sucesso')
              }

            })
          }
        })
        .catch((e) => {
          console.log(e)
          EventBus.$emit('showLoading', false)
          EventBus.$emit('showAlert', 'error', 'erro ao atualizar status')
          vm.currentTransaction.Status = vm.backupStatus
        })
    },

    callDelivery(transaction) {
      transaction.Status = this.STATUS_WAITING_TRANSPORT
      this.currentTransaction = transaction
      this.salvarStatus()
    },

    downloadBalanceSheet () {
      EventBus.$emit('showLoading', true)
      axios.get(this.getCheckoutApi+ '/xls/financialStatement/' + this.getCompany().companyId + '/' + this.monthFinancial + '/' + this.yearFinancial)
        .then((link) => {
          console.log(link.data)
          EventBus.$emit('showLoading', false)
          window.open(link.data, '_blank')
        })
        .catch((e) => { console.log('Erro creating xlsx', e); EventBus.$emit('showLoading', false)  })
    },

    downloadBalanceSheetSimple () {
      EventBus.$emit('showLoading', true)
      axios.get(this.getCheckoutApi+ '/xls/financialSimple/' + this.getCompany().companyId + '/' + this.dayFinancial2 + '/' + this.monthFinancial2 + '/' + this.yearFinancial2)
        .then((link) => {
          console.log(link.data)
          EventBus.$emit('showLoading', false)
          window.open(link.data, '_blank')
        })
        .catch((e) => { console.log('Erro creating xlsx', e); EventBus.$emit('showLoading', false)  })
    },

    openModalStatus (transaction) {
      this.currentTransaction = transaction
      this.backupStatus = transaction.Status
      this.showChangeStatus = true
    },

    closeModalStatus () {
      this.showChangeStatus = false
      this.currentTransaction.Status = this.backupStatus
    },

    print () {
      this.d.print( document.getElementById('printable'), this.cssText)
    },

    printThermalPrinter () {
      this.d.print( document.getElementById('printableThermalPrinter'), this.cssThermalPrinter)
    },

    openModalDetail (t) {
      console.log(t)
      this.rating = {}
      this.getRatingByOrderId(t.Id)
      this.currentTransaction = t
      try {
        this.currentTransaction.PaymentAddress = JSON.parse(this.currentTransaction.PaymentAddress)
      } catch (e) {
        // console.log(e)
      }
      this.showModalDetails = true
    },

    closeModalDetail () {
      this.showModalDetails = false
      this.rating = {}
    },

    openThermalPrinterModalDetail (t) {
      console.log(t)
      this.rating = {}
      this.getRatingByOrderId(t.Id)
      this.currentTransaction = t
      try {
        this.currentTransaction.PaymentAddress = JSON.parse(this.currentTransaction.PaymentAddress)
      } catch (e) {
        // console.log(e)
      }
      this.showModalDetails = false
      this.showThermalPrinterModalDetails = true
    },

    closeThermalPrinterModalDetail () {
      this.showThermalPrinterModalDetails = false
      this.rating = {}
    },

    tabIsActive (status) {
      return this.tabActive === status
    },

    filterByTab (status) {
      this.tabActive = status
    },

    playNewPurchase () {
      var audio = new Audio('/audios/register.mp3');
      audio.play();
    },


    refreshTransactions () {
      this.offsetDate = null
      this.offsetId = null
      this.getTransactions()
    },

    unionTransactions(newTransactions) {
      let toAdd = []
      let toUpdate = []
      for(let x=0; x<newTransactions.length; x++){
        let filtered = this.transactions.filter((t) => t.Id === newTransactions[x].Id)
        if (!filtered.length) {
          toAdd.push(newTransactions[x])
        } else {
          toUpdate.push(newTransactions[x])
        }
      }
      if (toAdd.length) {
        this.transactions = this.transactions.concat(toAdd);
      }
      for (let x=0; x<toUpdate.length; x++){
        for(let y=0; y<this.transactions.length; y++){
          if (this.transactions[y].Id === toUpdate[x].Id) {
            this.transactions[y] = toUpdate[x]
            break
          }
        }
      } 
      this.transactions.sort((a, b) => b.StatusHistory[0].statusDate - a.StatusHistory[0].statusDate);
      if (toAdd.length) {
        if (this.lastPurchase > 0 && this.lastPurchase < this.transactions[0].StatusHistory[0].statusDate) {
          this.lastPurchase = this.transactions[0].StatusHistory[0].statusDate
          this.playNewPurchase()
        } else if (this.lastPurchase == 0) {
          this.lastPurchase = this.transactions[0].StatusHistory[0].statusDate
        }
        this.$forceUpdate()
      }
    },

    autoUpdate () {
      this.offsetDate = null
      this.offsetId = null
      this.getTransactions(null, true)
      setTimeout(this.autoUpdate, 60000)
    },

    getTransactions (callback, hideLoading) {
      if (!hideLoading) {
        EventBus.$emit('showLoading', true)
      }
      this.loading = true
      axios.get(this.getCheckoutApi + '/transactions/company/'
        + this.getCompany().companyId + '?page_size=' + this.pageSize +
          (this.offsetDate ? '&offset_date='+this.offsetDate : '') +
          (this.offsetId ? '&offset_id='+this.offsetId : ''))
        .then((r) => {
          // r.data.sort((a, b) => b.StatusDate - a.StatusDate)
          if (r.data && r.data.length) {
            this.unionTransactions(r.data)
            // console.log(vm.transactions)
            this.offsetDate = r.data[r.data.length-1].StatusDate
            this.offsetId = r.data[r.data.length-1].Id
          } else {
            this.offsetDate = null
            this.offsetId = null
          }
          this.loading = false
          EventBus.$emit('showLoading', false)
          if (callback) {
            callback()
          }
        })
        .catch((e) => { console.log('error to fetch products', e); EventBus.$emit('showLoading', false)  })
    },

    getAllClients () {
      let vm = this
      axios.get(this.getOpaApi + '/user?companyId=' + this.getCompany().companyId)
        .then((r) => {
          if (r.data) {
            vm.clients = r.data
          } else {
            console.log('no client data')
          }
        })
        .catch((e) => {
          console.log(e)
          EventBus.$emit('showAlert', 'error', 'erro ao obter clientes')
        })
    },

    saveInnerCode (t) {

      if (t.statusComp !== undefined && t.statusComp !== null) {
        axios.put(this.getCheckoutApi + '/trans/statusComp/' + this.getCompany().companyId + '/' + t.Id + '/' + t.statusComp ,
        {},
        { headers: {'Content-Type': 'application/json'} }
        )
        .then((r) => {
          EventBus.$emit('showAlert', 'success', 'atualizado com sucesso')
          console.log(t, r)
        })
        .catch((e) => {
          console.log(e)
        })
      }

    },

    getStatusName (s, transaction) {
      let statusString = 'indefinido'
      let status = parseInt(s)

      switch (status) {
        case this.STATUS_KONDUTO_MANUAL:
          statusString = "Antifraude (Validação Manual)"
          break;
        case this.STATUS_TRANS_CREATED:
          statusString =  "Pedido Recebido"
          break;
        case this.STATUS_TRANS_PAY_CONFIRMED:
          statusString =  "Pagamento Confirmado"
          break;
        case this.STATUS_TRANS_REJECTED:
          if (transaction.konduto_response && transaction.konduto_response.order && transaction.konduto_response.order.recommendation === 'REVIEW') {
            statusString = "Pagamento Rejeitado (Antifraude - Suspeito)"
          } else if (transaction.konduto_response && transaction.konduto_response.order && transaction.konduto_response.order.recommendation === 'DECLINE') {
            statusString = "Pagamento Rejeitado (Antifraude - Negado)"
          } else {
            statusString = "Pagamento Rejeitado"
          }

          break;
        case this.STATUS_TRANS_W8_DELIVERY:
          statusString =  "Preparando Envio/Retirada"
          break;
        case this.STATUS_TRANS_TRANSPORT:
          statusString =  "Em Transporte"
          break;
        case this.STATUS_TRANS_DELIVERED:
          statusString =  "Entregue"
          break;
        case this.STATUS_TRANS_CANCELED_BY_STORE:
          statusString =  "Cancelado Lojista"
          break;
        case this.STATUS_TRANS_CANCELED_BY_BUYER:
          statusString =  "Cancelado Consumidor"
          break;
        case this.STATUS_TRANS_W8_TAKE:
          statusString =  "Aguardando retirada"
          break;
        case this.STATUS_TRANS_REJECTED_BUYER:
          statusString =  "Rejeitado consumidor"
          break;
        case this.STATUS_WAITING_TRANSPORT:
          statusString =  "Aguardando Transporte"
          break;
        case this.STATUS_PROCESSING_PAYMENT:
          statusString =  "Processando Pagamento"
          break;
        case this.STATUS_DELIVERY_PAYMENT:
          statusString =  "Pagamento na Entrega"
          break;
      }
      return statusString
    },

    getStatusClass (s) {
      let color = 'blackStatus'
      let status = parseInt(s)

      switch (status) {
        case this.STATUS_KONDUTO_MANUAL:
          color = 'manualStatus'
          break;
        case this.STATUS_TRANS_CREATED:
          color = 'greenStatus'
          break;
        case this.STATUS_TRANS_PAY_CONFIRMED:
          color = 'greenStatus'
          break;
        case this.STATUS_TRANS_REJECTED:
          color = 'redStatus'
          break;
        case this.STATUS_TRANS_W8_DELIVERY:
          color = 'orangeStatus'
          break;
        case this.STATUS_TRANS_TRANSPORT:
          color = 'orangeStatus'
          break;
        case this.STATUS_TRANS_DELIVERED:
          color = 'blueStatus'
          break;
        case this.STATUS_TRANS_CANCELED_BY_STORE:
          color = 'redStatus'
          break;
        case this.STATUS_TRANS_CANCELED_BY_BUYER:
          color = 'redStatus'
          break;
        case this.STATUS_TRANS_W8_TAKE:
          color = 'greenYellowStatus'
          break;
        case this.STATUS_TRANS_REJECTED_BUYER:
          color = 'redStatus'
          break;
        case this.STATUS_WAITING_TRANSPORT:
          color = 'purpleStatus'
          break;
        case this.STATUS_PROCESSING_PAYMENT:
          color = 'greenYellowStatus'
          break;
        case this.STATUS_DELIVERY_PAYMENT:
          color = 'pinkStatus'
          break;
      }
      return color
    }
  }
}
</script>

<style lang="scss" scoped>

.home {
  padding: 20px;
  width: calc( 100vw - 280px);
  text-align:left;

}

.border {
  border-right: 1px solid #706C7A;
}

.orangeStatus {
  padding:5px;
  cursor:pointer;
  background-color: #FFA300;
  color: #423D4E;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5);
}

.greenStatus {
  padding:5px;
  cursor:pointer;
  background-color: #98EB5E;
  color: #423D4E;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5);
}

.manualStatus {
  padding:5px;
  cursor:pointer;
  background-color: #b3ad42;
  color: #423D4E;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5);
}

.redStatus {
  padding:5px;
  cursor:pointer;
   background-color: #FF4E72;
  color: #FFFFFF;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5);
}

.blackStatus {
  padding:5px;
  cursor:pointer;
  background-color: #FFFFFF;
  color: #423D4E;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5);
}

.blueStatus {
  padding:5px;
  cursor:pointer;
  background-color: #5ee6eb;
  color: #423D4E;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5);

}

.purpleStatus {
  padding:5px;
  cursor:pointer;
  background-color: #9857b2;
  color: #423D4E;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5);

}

.greenYellowStatus {
  padding:5px;
  cursor:pointer;
  background-color: #c6cc72;
  color: #423D4E;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5);
}

.pinkStatus {
  padding:5px;
  cursor:pointer;
  background-color: #cc72ae;
  color: #423D4E;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5);
}


</style>
